import { Notification } from '@box/blueprint-web';
import { PrivateNotificationElement } from '@box/blueprint-web/lib-esm/primitives/notification/private-notification-element';
// @ts-expect-error [MIGRATION-SUPPRESSION]: TS1484
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import React from 'react';
import messages from './messages';

type BlueprintFormErrorNotificationProps = {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  errorMessage: any;
  intl: IntlShape;
  onClose: () => void;
};

const BlueprintFormErrorNotification = ({
  onClose,
  errorMessage,
  intl,
}: BlueprintFormErrorNotificationProps) => {
  const { formatMessage } = intl;
  const displayButton =
    errorMessage && errorMessage.values && errorMessage.values.info;

  return (
    <PrivateNotificationElement
      closeButtonAriaLabel={formatMessage(messages.closeButtonAriaLabel)}
      data-testid="blueprint-error-notification"
      onClose={onClose}
      sensitivity="foreground"
      styledText={<FormattedMessage {...errorMessage} />}
      typeIconAriaLabel={formatMessage(messages.errorIconAriaLabel)}
      variant="error"
    >
      {displayButton ? (
        <Notification.Button
          ariaLabel={formatMessage(messages.infoButtonLabel)}
          onClick={() =>
            window.open(errorMessage.values.info, '_blank', 'noreferrer')
          }
        >
          {/*
           // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322 */}
          <FormattedMessage {...messages.infoButtonLabel} />
        </Notification.Button>
      ) : null}
    </PrivateNotificationElement>
  );
};

export default injectIntl(BlueprintFormErrorNotification);
